<closeable-dialog class="mgub-dialog-container" [displayFooter]="showFooter">
  <div class="dialog-header title" dialog-card-header [ngStyle]="{'color':hasPassive ? '#FF1F00' : 'white'}">
    {{ mgubCastleDescription }}
  </div>
  <div dialog-card-body class="dialog-body">
    <nb-tabset (changeTab)="onTabChange($event)">
      <nb-tab
        [tabTitle]="'TAK' | translate"
        [active]="activeTab === 'TAK'"
        [tabId]="'TAK'">
        <div class="centered-image">
          <img *ngIf="isTak === false" class="img1" src="assets/images/mgub.png" width="300" height="250"/>
        </div>
        <div *ngIf="isTak === false">
          <div *ngFor="let sensorMap of sensorMaps | keyvalue">
            <div class="dialog-item">
              <div class="d-flex" (click)='setVisibility(sensorMap.key)' [ngStyle]="{'cursor': 'pointer', 'background': !isCollapsedMap.get(sensorMap.key) ? '#1E1E1E' : '#2A2A2A', 'border-radius':'5px'}">
                <div [ngClass]="'title'">
                  {{ sensorMap.key | translate }}
                </div>
                <div [ngClass]="'title left-icon'" *ngIf='hasPassiveSensor(sensorMap.key)'>
                  <i class="fa fa-exclamation-triangle"></i>
                </div>
                <div *ngIf='isCollapsedMap.get(sensorMap.key)' [ngClass]="'title right-icon'">
                  <i class="fa fa-2x fa-caret-right"></i>
                </div>
                <div *ngIf='!isCollapsedMap.get(sensorMap.key)' [ngClass]="'title right-icon'">
                  <i class="fa fa-2x fa-caret-down"></i>
                </div>
              </div>
              <div *ngIf='!isCollapsedMap.get(sensorMap.key)'>
                <table id="sensor-table">
                  <tr [ngClass]="'header'">
                    <th>{{ 'sensorId' | translate }}</th>
                    <th>{{ 'status' | translate }}</th>
                    <th>{{ 'description' | translate }}</th>
                  </tr>
                  <tr *ngFor="let sensor of sensorMap.value">
                    <td>
                      <div [ngClass]="{'redDiv':sensor.status === 'Pasif' || sensor.status === 'Durum Bilgisi Yok'}">
                        {{ sensor.sensorId }}
                      </div>
                    </td>
                    <td>
                      <div [ngClass]="{'redDiv':sensor.status === 'Pasif' || sensor.status === 'Durum Bilgisi Yok'}">
                        {{ sensor.status }}
                      </div>
                    </td>
                    <td>
                      <div [ngClass]="{'redDiv':sensor.status === 'Pasif' || sensor.status === 'Durum Bilgisi Yok'}">
                        {{ sensor.description }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isTak" class="iframe-wrapper">
          <div class="iframe-grid">
            <div class="iframe-container">
              <p>{{ streams[0].name | translate }}</p>
              <iframe
                class="stream-frame"
                src='https://camera.geleceginsehri.com/camera2/'
                frameborder="0"
                allow="fullscreen; autoplay; picture-in-picture"
                loading="lazy"
                allowfullscreen>
              </iframe>
            </div>
            <div class="iframe-container">
              <p>{{ streams[1].name | translate }}</p>
              <iframe
                class="stream-frame"
                src='https://camera.geleceginsehri.com/camera1/'
                frameborder="0"
                allow="fullscreen; autoplay; picture-in-picture"
                allowfullscreen
                loading="lazy">
              </iframe>
            </div>
          </div>
          <div class="camera-button-container">
            <button [disabled]="playButtonDisabled" (click)="playCamera(streams[0].commandUrl)" class="camera-control-btn">{{ 'De-activate' | translate }}</button>
            <button [disabled]="freezeButtonDisabled" (click)="freezeCamera(streams[0].commandUrl)" class="camera-control-btn">{{ 'Activate' | translate }}</button>
          </div>
        </div>
      </nb-tab>
      <nb-tab
        [tabTitle]="'PTZ AUTH BYPASS' | translate"
        [active]="activeTab === 'PTZ'"
        [tabId]="'PTZ'">
        <div *ngIf="isTak" class="iframe-wrapper">
          <div class="iframe-grid">
            <div class="iframe-container">
              <p>{{ streams[2].name | translate }}</p>
              <iframe
                class="stream-frame"
                src='https://camera.geleceginsehri.com/dahua1/'
                frameborder="0"
                allow="fullscreen; autoplay; picture-in-picture"
                loading="lazy"
                allowfullscreen>
              </iframe>
              <div class="camera-button-container">
                <button [disabled]="panLeftDisabled" (click)="onPanMove(streams[2].commandUrl, 'Left')" aria-label="Pan" class="camera-control-btn">
                  <i class="fa fa-arrow-left icon-left" aria-hidden="true"></i>
                </button>
                <button onclick="window.open('http://188.59.180.172:180', '_blank')" class="camera-control-btn">{{ 'cameraAdminPanel' | translate }}</button>
                <button [disabled]="panRightDisabled" (click)="onPanMove(streams[2].commandUrl, 'Right')" aria-label="Pan" class="camera-control-btn">
                  <i class="fa fa-arrow-right icon-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="iframe-container">
              <p>{{ streams[3].name | translate }}</p>
              <iframe
                class="stream-frame"
                src='https://camera.geleceginsehri.com/dahua2/'
                frameborder="0"
                allow="fullscreen; autoplay; picture-in-picture"
                loading="lazy"
                allowfullscreen>
              </iframe>
              <div class="camera-button-container">
                <button [disabled]="panLeftDisabled" (click)="onPanMove(streams[3].commandUrl, 'Left')" aria-label="Pan" class="camera-control-btn">
                  <i class="fa fa-arrow-left icon-left" aria-hidden="true"></i>
                </button>
                <button onclick="window.open('http://188.59.180.172:280', '_blank')" class="camera-control-btn">{{ 'cameraAdminPanel' | translate }}</button>
                <button [disabled]="panRightDisabled" (click)="onPanMove(streams[3].commandUrl, 'Right')" aria-label="Pan" class="camera-control-btn">
                  <i class="fa fa-arrow-right icon-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nb-tab>
    </nb-tabset>
  </div>
  <div dialog-card-footer class="dialog-footer">
    <div dialog-card-footer class="footer-left">
      <label class="column-info title">{{ 'coordinate' | translate }}: </label>
      <label class="column-info content">{{ mgubCastleLocation }}</label>
    </div>
    <div *ngIf="isTak === false" dialog-card-footer class="footer-right">
      <label style="color:red;" class="column-info content">{{ this.passiveSensorCount }} &nbsp; </label>
      <label class="column-info content"> / {{ this.paginatedSensors.length }}</label>
      <label class="column-info content">&nbsp;{{ 'sensor' | translate }}</label>
    </div>
  </div>
</closeable-dialog>


